export default __webpack_public_path__ + "static/uCall x Bat Dong San_page-0001-7ad73093d448d5257188c2ec4606bbae.jpg";